import React, { Fragment } from "react";

import { required, InputField, SmartSelect, DateField } from "modules/4_final_form/mobile";

import { Button, List, Block, BlockTitle } from "framework7-react";

import { Field } from "react-final-form";
import { getEmployees } from "modules/employees/actions";
import { getStoreOverallsStatuses } from "../statuses/actions";
import { connect } from "react-redux";
import _ from "lodash";
import { getStoreOverallsGarments } from "../garments/actions";

function mapStateToProps(state) {
  return {
    employees: state.employees,
    store_overalls_statuses: state.store_overalls_statuses,
    store_overalls_garments: state.store_overalls_garments,
  };
}

class StoreOverallForm extends React.Component {
  constructor(props) {
    super(props);

    this.props.getEmployees();
    this.props.getStoreOverallsStatuses();
    this.props.getStoreOverallsGarments();
  }

  render() {
    const { handleSubmit, formLabel, employees, store_overalls_statuses, store_overalls_garments, values } = this.props;

    const { barcodes } = values;

    return (
      <form>
        {!_.isEmpty(barcodes) && (
          <Block>
            <BlockTitle>Barcodes ({_.size(barcodes)})</BlockTitle>
            {_.map(barcodes, (code, index) => (
              <Fragment>
                {code}
                <br />
              </Fragment>
            ))}
            <hr />
          </Block>
        )}
        <List>
          {_.isEmpty(barcodes) && (
            <Field component={InputField} label="Barcode" name="barcode" placeholder="Enter barcode..." slot="list" validate={required} />
          )}
          <Field
            component={SmartSelect}
            name="garment_id"
            options={_.map(store_overalls_garments, (gar) => {
              return { value: gar.id, label: gar.name };
            })}
            label="Garment"
            placeholder="Select Garment"
            slot="list"
            validate={required}
            valueName="value"
            labelName="label"
            searchbar
            searchbarPlaceholder="Search Garments"
          />
          <Field component={DateField} label="Issue Date" name="issue_date" slot="list" validate={required} />

          <Field
            component={SmartSelect}
            name="employee_id"
            options={_.map(_.sortBy(employees, ["last_name", "first_name"]), (emp) => {
              return { value: emp.id, label: emp.display_name };
            })}
            label="Employee"
            placeholder="Select Employee"
            slot="list"
            validate={required}
            valueName="value"
            labelName="label"
            searchbar
            searchbarPlaceholder="Search Employees"
          />
          <Field
            component={SmartSelect}
            name="status_id"
            options={_.map(store_overalls_statuses, (emp) => {
              return { value: emp.id, label: emp.name };
            })}
            label="Status"
            placeholder="Select Status"
            slot="list"
            validate={required}
            valueName="value"
            labelName="label"
            openIn="popover"
          />
        </List>

        <Block>
          <Button onClick={handleSubmit} fill color="green">
            {formLabel} Store Overall
          </Button>
        </Block>
      </form>
    );
  }
}

export default connect(mapStateToProps, { getEmployees, getStoreOverallsStatuses, getStoreOverallsGarments })(StoreOverallForm);

// {
/* <FormGroup row>
<Label md={2}>Barcode</Label>
<Col md={4}>
  <Field component={InputField} name="barcode" type="string" parse={(value) => value} validate={required} />
</Col>
</FormGroup>
<FormGroup row>
<Label md={2}>Employee</Label>
<Col md={4}>
  <Field
    component={ReactSelect}
    name="employee_id"
    options={_.map(employees, (emp) => {
      return { value: emp.id, label: emp.display_name };
    })}
    validate={required}
  />
</Col>
</FormGroup>
<FormGroup row>
<Label md={2}>Status</Label>
<Col md={4}>
  <Field
    component={ReactSelect}
    name="status_id"
    options={_.map(store_overalls_statuses, (sos) => {
      return { value: sos.id, label: sos.name };
    })}
    validate={required}
  />
</Col>
</FormGroup> */
// }
